import React from "react";

function Footer() {
  return (
    <footer className="bg-[#DDE6ED] text-[#27374D] font-semibold p-4 w-screen">
      <div className="container mx-auto text-center">
        <p>&copy; Harsh Patel.</p>
      </div>
    </footer>
  );
}

export default Footer;
